import type { Alert } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { useUpdateAlert } from "./useUpdateAlert"
import {
  useDebouncedUpdater,
  useShowGenericErrorToast,
} from "src/hooks/forms"

export function useDebouncedUpdateAlert(
  sugarmateAlert: Alert | undefined,
  errorToastId: string,
) {
  const onError = useShowGenericErrorToast(errorToastId)

  const updateAlert = useUpdateAlert()
  const debouncedUpdateAlert = useDebouncedUpdater({
    updater: updateAlert,
    onError,
  })

  return useCallback(
    (partialSugarmateAlert: Partial<Alert>) => {
      if (!sugarmateAlert) {
        onError()
        return
      }

      debouncedUpdateAlert({
        id: sugarmateAlert.id,
        ...partialSugarmateAlert,
      })
    },
    [
      debouncedUpdateAlert,
      sugarmateAlert,
      onError,
    ],
  )
}
